// extracted by mini-css-extract-plugin
export default {"body":"ManualStockAdjustment_body__Feo8a"};